<!-- 选项 -->
<template>
  <div class="option-comp" v-if="dataList && dataList.length">
    <ul>
      <!-- <div class="option-title">{{ $lang('选项') }}</div> -->
      <li v-for="(item, index) in dataList" :key="index">
        <!-- <span class="li-title">{{ $lang('选项') }}{{ index + 1 }}：</span>
        <span class="li-content">{{ item }}</span> -->
        <el-button round disabled class="button-name">{{ item }}</el-button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'OptionComp',
  props: ['option'],
  created() {
    this.dataList = this.option.content
  },
  data() {
    return {
      dataList: null
    }
  }
}
</script>

<style lang="scss" scoped>
.option-comp {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
  ul {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .option-title {
      font-size: 14px;
      line-height: 20px;
      @include text-color('main');
      text-align: left;
      font-weight: bold;
      margin-bottom: 3px;
      padding-left: 3px;
    }
    li {
      margin-bottom: 5px;
      line-height: 20px;
      text-align: right;
      .button-name{
        margin-left: 10px;
      }
    }
  }
}
</style>
